// extracted by mini-css-extract-plugin
export default {"wrapper":"fs-z","response":"gs-z","error":"hs-z","disabled":"is-z","buttons":"js-z","feedbackQuestionSection":"ks-z","yesNoWrapper":"ls-z"};